import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@material-ui/core'

import TextInfoDisplay from '../../components/TextInfoDisplay'
import DownloadLink from '../../components/DownloadLink'

export default function Formulario (props) {
  const [loaded, setLoaded] = useState(false)
  const { formId } = props.match.params
  const forms = useSelector(state => {
    return state.formularios
  })
  const [form, setForm] = useState({})
  
  useEffect(() => {
    if (!form || !form.id) {
      const f = forms.find(f => f.id == formId)
      setForm(f)
    }

    setLoaded(true)
  }, [])

  return (
    <>
      <Grid item xs={1} md={4} />
      <Grid item xs={10} md={4}>
        <TextInfoDisplay
          label='Nome do dentista:'
        >
          { form.nome ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Email:'
        >
          { form.email ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Nome do paciente:'
        >
          { form.nomepaciente ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Telefone:'
        >
          { form.telefone ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='WhatsApp:'
        >
          { form.whatsapp ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Documento:'
        >
          { form.documento ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label=' Tipo de caso:'
        >
          { form.tipodecaso ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Região do tratamento:'
        >
          { form.regiaotratamento ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Envio de coroas provisórias:'
        >
          { form.tipodeprotese ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Forma de envio:'
        >
          { form.formaenvio ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Observações:'
        >
          { form.observacoes ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Link we-transfer:'
        >
          { form.linkwetransfer ?? ''}
        </TextInfoDisplay>
        <TextInfoDisplay
          label='Arquivos em anexo:'
        >
          { 
            form.uploads ? form.uploads.map(u => (
              <DownloadLink href={u.url}>{u.name}</DownloadLink>
            )) : ''
          }
        </TextInfoDisplay>
      </Grid>
    </>
  )
}